import {Box, Container, Divider, IconButton, Typography} from "@mui/material";
import {InstagramLogoIcon, MailboxIcon} from "@phosphor-icons/react";
import pixel from "../res/pixel.png";

export default function Footer() {
    return (
        <Container component={"footer"} maxWidth={"lg"} sx={{pb: 4, backgroundColor: "transparent"}}>
            {/* thickness and rounded ends */}
            <Divider/>
            <Typography component={"a"} href={"/privacy.html"} display={"block"} color={"inherit"} sx={{pt: 3}}>
                Privacy
            </Typography>
            <Typography component={"a"} href={"/terms.html"} display={"block"} color={"inherit"}>
                Terms
            </Typography>
            <Box sx={{
                pt: 3,
                display: "flex",
                alignItems: "center",
            }}>
                <Typography variant="body1" fontWeight={"bold"} sx={{flexGrow: 1}}>
                    Copyright © {new Date().getFullYear()} Personally.
                </Typography>
                <IconButton>
                    <img alt={""} src={pixel}/>
                </IconButton>
                <IconButton color={"inherit"} href={"https://www.instagram.com/personallytheapp/"}>
                    <InstagramLogoIcon/>
                </IconButton>
                <IconButton color={"inherit"} href={"mailto:hi@personally.app"}>
                    <MailboxIcon/>
                </IconButton>
            </Box>
        </Container>
    );
}